module.exports = __webpack_public_path__ + "img/호주 국기.22a2d11b.png";